import { render, staticRenderFns } from "./SpeakingPhonics1.vue?vue&type=template&id=f1d7695c&scoped=true&"
import script from "./SpeakingPhonics1.vue?vue&type=script&lang=js&"
export * from "./SpeakingPhonics1.vue?vue&type=script&lang=js&"
import style0 from "./SpeakingPhonics1.vue?vue&type=style&index=0&id=f1d7695c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d7695c",
  null
  
)

export default component.exports